<!-- 搜索结果 - 父组件 -->
<template>
  <div style="width: 100%;min-height: calc(100% - 112px);">
      <div class="type_container">
          <ul class="nav">
              <li :class="{selected: type.isSelected}" @click="changeType(type.value)" v-for="(type, index) in types">
                {{type.name}}
              </li>
          </ul>
      </div>
      <div class="results noResults" v-if="hasResult">
          <p class="noResTip">很抱歉，没有搜索到与“<b>{{keyword}}</b>”相关的{{typeDesc[currentTab]}}</p>
          <div class="noResSubTip">
              <p>温馨提示：</p>
              <p class="tip-item">请检查您的输入是否正确</p>
          </div>
      </div>
      <div class="results" v-else>
          <!--<router-view @gotoPage="goto" :results="results" @savingEvidence="saveEvidence" @changeChild="changeTab">-->
          <router-view @gotoPage="goto" :results="results" @savingEvidence="saveEvidence">

          </router-view>
          <paging :page="results.page" :isAsync="isAsync" @gotoPage="goto" v-if="isPage"></paging>
      </div>
      <!-- save evidence -->
      <transition name="fade">
          <div class="popup-box save-evidence-box"  v-if="showSave">
              <div id="save-evidence-modal" class="bgshade-box"></div>
              <div class="con-box">
              <p class="save-evidence-row clearfix">
                  <span class="save-evidence-tit">存证</span>
                  <span class="save-evidence-close" @click="closePopup">x</span>
              </p>
              <div class="save-evidence-content">
              <p>
                  <label>标题：</label>
                  <span :title="saveInfo.webTitle">{{saveInfo.webTitle}}</span>
              </p>
              <p>
                  <label>URL：</label>
                  <span :title="saveInfo.saveUrl">{{saveInfo.saveUrl}}</span>
              </p>
              <p>
                  <label>计费：</label>
                  <span>{{charging[currentTab]}}</span>
              </p>
              <p class="totalFee">
                  <label>共计：</label>
                  <span>{{totalSum}} 元（若账户有折扣则实际扣款是折扣额度）</span>
              </p>
            </div>
            <div class="save-evidence-select">
                <p v-if="isEnough">
                    <button href="javascript:;" class="go-cofirm go-btn" @click="goConfirm">确认</button>
                </p>
                <p v-else>
                    <a href="javascript:;" class="go-alipay" @click="goAliPay">支付宝支付</a>
                    <a href="javascript:;" class="go-personal-center go-btn" @click="goPersonalCenter">去充值</a>
                </p>
            </div>
          </div>
          </div>
      </transition>
      <!-- 是否支付成功弹窗 -->
      <transition name="fade">
          <div class="popup-box is-pay-box" v-if="isPaid">
              <div class="bgshade-box"></div>
              <div class="con-box">
                  <h4>充值</h4>
                  <form class="pay-con-box">
                      <p class="form-item money-pay pay-status">
                        <a href="javascript:;" @click="payComplete">完成支付</a>
                      </p>
                      <p class="form-item money-pay pay-status">
                        <a href="javascript:;" @click="payComplete">支付失败</a>
                      </p>
                      <p class="form-item customer-service">联系客服：010-84770602</p>
                  </form>
              </div>
          </div>
      </transition>
      <!--<div class="page_container">-->
        <!--<ul class="nav page">-->
          <!--<li class="single_page">上一页</li>-->
          <!--<li class="specified_page" :class="{selected: n == results.paging.pageNum}" v-for="n in results.paging.shown">-->
            <!--{{n}}-->
          <!--</li>-->
          <!--<li class="single_page">下一页</li>-->
        <!--</ul>-->
      <!--</div>-->
  </div>
</template>

<style scoped>
    p{
      marign: 0;
    }
    a{
      text-decoration: none;
      color: #fff;
    }
    button{
      border:0;
      outline: 0;
    }
    .nav{
      /*解决搜索结果页面跳动*/
      /*padding-left: calc(100vw - 100%);*/
    }
    .type_container {
      width: 100%;
      background-color: #f4f4f4;
      height: 44px;
      margin-bottom: 20px;
    }

    .type_container ul {
      height: 100%;
      line-height: 100%;
      /*width: 440px;*/
      width: 1024px;
      margin: 0 auto;
      /*margin-left: 181px;*/
    }
    .type_container li {
      color: #848484;
      font-size: 0.875rem;
      height: 43px;
      line-height: 43px;
      margin-right: 60px;
      padding: 0 2px;
      cursor: pointer;
      box-sizing: border-box;
      width: 44px;
      text-align: center;
      border-bottom: 3px solid transparent;
      float: left;
    }
    .type_container li:nth-child(3){
      margin-left: 206px;
      margin-top: -43px;
    }
    .type_container li:nth-child(4){
      margin-left: 306px;
      margin-top: -43px;
    }

    .type_container li.selected {
      border-bottom: 3px solid #a12935;
      color: #3a3a3c;
    }

    .results{
      width: 1024px;
      margin: 0 auto;
      /*overflow: auto;*/
      /*padding-left: calc(100vw - 100%);*//*解决搜索结果页面跳动*/
    }
    .noResults .noResTip{
      font-size: 14px;
      padding-top: 10px;
    }
    .noResults .noResTip b{
        font-size: 18px;
        color: #a12935;
        font-weight: normal;
    }
    .noResults .noResSubTip{
        margin-top: 22px;
        font-size:14px;
        color:#666;
    }
    .noResults .noResSubTip .tip-item{
        margin-top: 5px;
        padding-left: 14px;
        background-image: url(../../assets/tip_icon.png);
        background-repeat: no-repeat;
        background-position: 0px 7px;
    }
  .page_container {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .page li {
    border-radius: 1px;
    border: solid 1px #e6e6e6;
    cursor: pointer;
    height: 0.75rem;
    line-height: 0.75rem;
    font-size: 0.75rem;
    text-align: center;
    color: #a12935;
    padding: 4px 6px;
    margin-right: 5px;
  }

  /*.page li.single_page{*/
  /*width: 36px;*/
  /*}*/
  .page li.selected {
    background-color: #be2231;
    color: #ffffff;
  }

    /* basis style */
    .popup-box,.bgshade-box{
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .bgshade-box{
      background-color: rgba(0,0,0,0.5);
      font-size: 16px;
      filter: alpha(opacity=50);
      box-sizing: border-box;
    }
    .popup-box{
      z-index: 999!important;
    }
    .con-box{
      font-size: 14px;
      width:639px;
      background: #fff;
      border-radius: 5px;
      border:1px solid #Eb828c;
      padding: 0 19px;
      position: absolute;
      top:28%;
      left: 50%;
      transform: translate(-320px,0);
    }
    @media (min-height: 670px){
      .con-box{
        top: 34%;
      }
    }
    /*
        Save Evidence Style
    */
    .save-evidence-box .save-evidence-row{
      /*height: 20px;*/
      margin-top: 19px;
      color:#b11828;
      font-weight: normal;
      font-size: 16px;
      padding-bottom: 15px;
    }
    .save-evidence-box .save-evidence-tit{
      float: left;
    }
    .save-evidence-box .save-evidence-close{
      float: right;
      cursor: pointer;
    }
    .save-evidence-box .save-evidence-content{
      border-top:1px solid #d2d2d2;
      border-bottom:1px solid #d2d2d2;
      padding-top:16px;
      padding-bottom: 16px;
    }
    .save-evidence-content{
      padding-left: 127px;
    }
    .save-evidence-content p{
      height:40px;
      line-height:40px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .save-evidence-content p.totalFee {
      color:#f00;
    }
    .save-evidence-select p{
      font-size: 14px;
      margin: 15px 0 8px;
      height:40px;
      line-height: 36px;
    }
    .save-evidence-select .go-alipay{
      color: #0046ef;
      margin-left: 150px;
    }
    .save-evidence-select .go-btn{
      width:114px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background-color: #A12935;
      border-radius: 4px;
      color: #fff;
      position: relative;
      left: 50%;
      margin-left: -57px;
      cursor: pointer;
    }
    .save-evidence-select .go-btn:hover{
      background-color: #c11c27;
    }
    .save-evidence-select .go-personal-center{
      float: right;
      left: -170px;
    }
    /*
        pay  popup style
    */
    .is-pay-box .pay-con-box{
      overflow: hidden;
    }
    .is-pay-box .con-box{
      width:639px;
      height:377px;
      background: #fff;
      border-radius: 5px;
      border:1px solid #Eb828c;
      /*padding: 16px 17px;*/
      box-sizing: border-box;
    }
    .is-pay-box h4{
      font-size: 16px;
      color: #a12935;
      height: 36px;
      line-height: 36px;
      font-weight: normal;
      position: relative;
      border-bottom: 1px solid #d2d2d2;
    }
    /*.is-pay-box .closePopup{*/
      /*position: absolute;*/
      /*right: 18px;*/
      /*top: 20px;*/
      /*color: #a12935;*/
      /*font-size: 16px;*/
      /*cursor: pointer;*/
    /*}*/
    .is-pay-box p.form-item{

    }
    .is-pay-box p.money-pay{
      height: 40px;
      line-height: 40px;
    }
    .is-pay-box p.money-pay a{
      display: block;
      width: 50%;
      text-align: center;
      color: #fff;
      background-color: #b71d2a;
      height: 40px;
      border-radius: 6px;
      margin:0 auto;
    }
    .is-pay-box p.pay-status{
      margin: 30px 0;
    }
    .is-pay-box p.customer-service{
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #6b6b6b;
      overflow: hidden;
      padding: 30px 0 23px;
      box-sizing: border-box;
      border-bottom: 1px solid #d2d2d2;
    }
</style>

<script>
  import Paging from '@/components/common/Paging';
  import Modal from '../common/MsgModal';
  import Loading from '../common/Loading';
  //import ReferrerKiller from '@/lib/referrer-killer'

  export default {
    name: 'ResultContainer',
    components: { Paging, Modal,Loading},
    data(){
        return{
          userInfo: {},
          currentTab: 'text',
          typeDesc:{
            text: '文字',
            images: '图片',
            audios: '音频',
            videos: '视频'
          },
          keyword:'',
          pageNum:1,
          pageSize:20,
          hasResult:false,
          isEnough: false,
          isPage:true,
          showSave: false,
          saveIndex:-1,
          time: 10,
          imageArr:[],
          saveInfo: {
              title:'',
              url:''
          },
//          isLoading:false,
          totalSum:0,
          requestType:'',
          totalChanging:0,
          charging:{
              text: '5元/条',
              images: '5元/条',
              audios: '1元/分钟',
              videos: '1元/分钟'
          },
          searchTypes:{
              text: 90001,
              images: 90002,
              audios: 90003,
              videos: 90004,
          },
          saveType:{
              text:1,
              images:2,
              audios:3,
              videos:4
          },
          types: [
            {
              name: '文字',
              value: 'text',
              isSelected: true
            },{
              name: '图片',
              value: 'images',
              isSelected: false
            },{
              name: '音频',
              value: 'audios',
              isSelected: false
            },{
              name: '视频',
              value: 'videos',
              isSelected: false
            },
          ],
          results: {
            data: [],
            page: {
            }
          },
          isPaid:false,
          evidence:'',
          isAsync: false,
          getAccountNum:0,       //轮询搜索结果总条目的计时器号码
          timestampDR:0,
        }
    },
    created () {
      this.$store.commit('setCurrentHeader', 'results');
    },
    mounted () {
        console.log('result mounted hook');
        this.init();
    },
    methods: {
      init () {  //组件初始化（包括tab变化）
          let user = {};
          this.hasResult = false;
          this.imageArr = [];
          let current = this.$router.history.current;
          this.userInfo = this.$getLocalStorage('IP360', 'user');
          this.keyword = decodeURIComponent(current.query.keyword);
          this.currentTab = current.path.substring(current.path.lastIndexOf('/')+1);
          if(this.currentTab=='images'){
            this.isPage = false;
          } else {
            this.isPage = true;
          }
          let that = this;
          this.types.forEach(function(item){
            item.isSelected = false;
            if(that.currentTab == item.value){
              item.isSelected = true;
            }
          });
          this.goto();
      },
      dataRequest () {
          this.$store.commit('showLoading',true);
//          this.hasResult = true;
//          return;
          this.isPage = false;
          this.hasResult = false;
          //处理ID 未登录传-1
          let userId = -1;
          // let newTab = this.currentTab;
          this.timestampDR = Date.now();
          //console.log(this.keyword+':'+ this.timestampDR);
          if(this.userInfo != null && this.userInfo.id){
              userId = this.userInfo.id
          }
          if(this.currentTab=='images'){
            this.pageSize = 50;
            if(this.pageNum>1 && this.imageArr.length<1){
              this.pageSize = this.pageSize*this.pageNum
              this.pageNum = 1;
            }
          }else{
            this.pageSize = 20;
            //初始化
            this.results.data = [];
          }
          this.$store.commit('showContentFooter', false);
          //请求数据
          this.$axios.request({
              url: '/webapi/sc/search',
              method: 'GET',
//              timeout:122*1000,
              params: {
                  wk:this.keyword,
                  wt:this.searchTypes[this.currentTab],
                  pageNo:this.pageNum,
                  pageSize:this.pageSize,
                  userId: userId,
                  token: this.userInfo.token,
                  timestamp: this.timestampDR
              }
          }).then(response=>{
              // console.log('response of result container is: ', response);
              /*f(newTab != this.currentTab){
                  return;*/
              if(this.timestampDR != response.data.timestamp){
                  return;
              }else {
                  this.$store.commit('showLoading',false);
                  if(this.currentTab=='images'){
                    this.isPage = false;
                  } else { 
                    this.$store.commit('showContentFooter', true);
                    this.isPage = true;
                  }
                  if(response.data.code==200){
//                    console.log('search result res:', response);
                      let res = response.data.datas.resultList.list;
                      if(res.length != 0){
                          this.hasResult = false;
                      }
                      let that = this;
                      res.forEach(function(item){
                          //处理时间
                          if(!item.time){
                              item.time = 10;
                          }
                          //处理存证状态和关键字描红
                          if(item.saveStatus==1||item.saveStatus==0){
                              item.statusDesc = '存证中';
                              item.hasAction = false;
                          } else if(item.saveStatus==2) {
                              item.statusDesc = '已存证';
                              item.hasAction = false;
                          }else{
                              item.hasAction = true;
                          }
                          if(that.currentTab == 'images'){
                            item.imgObj = {
                              src: item.imgUrl,
                              error: require('../../assets/imgRes/error.png'),
                              loading:require('../../assets/imgRes/loading2.gif'),
                            }
                          }
                          if(that.currentTab == 'videos'){
                            item.imgObj = {
                              src: item.imgSrc,
                              error: require('../../assets/imgRes/error.png'),
                              loading: require('../../assets/imgRes/loading3.gif'),
                            }
                          }
                          if(that.currentTab == 'text'){
                            if(item.link){
                              item.showUrl = item.link
                            }else{
                              item.showUrl = item.webUrl
                            }
                          }
                          //关键字描红
                          let escapeKw = that.keyword;
                          let specialChar = {'\\':'\\\\', '*':'\\*', '.':'\\.', '?':'\\?', '+':'\\+', '$':'\\$', '^':'\\^', '[':'\\[', ']':'\\]', '(':'\\('
                          , ')':'\\)', '{':'\\{', '}':'\\}', '|':'\\|', '/':'\\/'};
                          for(let key in specialChar){
                            // console.log(key, ":" , specialChar[key]);
                            let escapeKwArr = escapeKw.split('');
                            for(let i in escapeKwArr){
                              escapeKwArr[i] = escapeKwArr[i].replace(key, specialChar[key]);
                            }
                            escapeKw = escapeKwArr.join('');
                          }
                          // console.log('escapeKw:', escapeKw)
                          let reg = new RegExp(escapeKw,'gi');
                          item.webTitleFormat = item.webTitle.replace(reg,'<span style="color:red;">'+that.keyword+'</span>');
                          item.webContent = item.webContent || item.introduce;
                          if(item.webContent){
                              item.webContentFormat = item.webContent.replace(reg,'<span style="color:red;">'+that.keyword+'</span>');
                          }
                      });

                      this.results.data = res;
                      this.results.page = response.data.datas.resultList.pageSetting;
                      if(this.currentTab=='images'){
                          for(var i in res){
                              this.imageArr.push(res[i]);
                          }
                      }else{
                        $(window).scrollTop(()=>{
                          $('body,html').animate({ scrollTop: 0 });
                        });
                        if(this.getAccountNum != 0){
                          clearInterval(this.getAccountNum);
                          this.getAccountNum = 0;
                        }
                        this.getAccount();
                    }
                  } else if(response.data.code==80001){
                      //没有结果
                      this.hasResult = true;
                  } else if(response.data.code!=102 || response.data.code!=103 ){
                      this.$store.dispatch('showMsgModal',{
                        autoClose:false,
                        info:response.data.msg
                      });
                  }
              }
            })
      },
      getAccount(){
        if(this.getAccountNum == 0){
          let page = this.results.page;
          let that = this;
          // console.log('page is ', page);
          if(page.totalPage < page.endPage){
            that.getAccountNum = setInterval(function(){
                that.$axios.request({
                  url: '/webapi/sc/getAccount',
                  method: 'GET',
                  params: {
                    keyword:that.keyword,
                    token:this.userInfo?this.userInfo.token:'',
                    type:that.searchTypes[that.currentTab],
                  }
                }).then(response => {
                  // console.log('response in getAccount',response);
                  let datas = response.data.datas;
                  page.totalPage = datas.totalPage;
                  if(page.totalPage > page.pageNumber){
                    page.lastPage = false;
                  }
                  let totalPageStr = datas.totalPage.toString();
                  let lastPos = totalPageStr.substring(totalPageStr.length-1);
                  that.results.page.selected = parseInt(lastPos);
                  if(datas.totalPage >= page.endPage){
                    clearInterval(that.getAccountNum);
                    that.results.page.shown = 10;
                    that.getAccountNum = 0;
                  }else{
                    that.results.page.shown = parseInt(lastPos);

                  }
                });
              }, 3000);
            }
          }
      },
      changeType(type){
          if(this.currentTab == type){
              if(this.pageNum == 1){
                this.$router.go(0);
              }else{
                this.$router.push({path: '/results/'+ type, query:{
                  keyword: encodeURIComponent(this.keyword),
                  pageNum: 1
                }});
              }
          }else{
            this.$router.push({path: '/results/'+ type, query:{
                keyword: encodeURIComponent(this.keyword),
                pageNum: 1
            }});
          }

      },

//      changeTab: function(type, keyword){
//        this.results.data = [];
//        this.imageArr = [];
//        this.keyword = keyword;
//        this.currentTab = type;
//        if(this.currentTab=='images'){
//          this.isPage = false;
//        } else {
//          this.isPage = true;
//        }
////            event.target.className = 'selected';
//        this.types.forEach(function(item){
//          item.isSelected = false;
//          if(type == item.value){
//            item.isSelected = true;
//          }
//        });
//        this.dataRequest();
////          this.types[index].isSelected = true;
////          this.$router.push('/results/'+ type +'/')
//      },
      goto(pageNum){
        let current = this.$router.history.current;
        if(!pageNum){
          this.pageNum = current.query.pageNum || 1;
        }else{
          this.pageNum = pageNum;
        }
        this.dataRequest();
      },
      saveEvidence(index){
          this.saveIndex = index;
          //处理时间
          let time = this.currentTab == 'videos'? this.results.data[index].time+'':'10';
          if(time.indexOf(':') != -1){
              time = time.split(':');
              if(time.length==2){
                  time.unshift(0);
              }
              if(parseInt(time[2])>0){
                  time[2] = 1;
              }
              time = parseInt(time[0])*60 + parseInt(time[1]) + parseInt(time[2]);
          }
          this.time = parseInt(time);
          console.log('other time:',this.time);
          //存证路径
          // let url = '';
          // if(this.currentTab == 'audios' || this.currentTab == 'text'){
          //     url = this.results.data[index].webUrl;
          // }
          let url=this.currentTab=='audios'||this.currentTab=='text'?this.results.data[index].webUrl:'';
          console.log('url:',url);
          //用户已经登录
          if(this.userInfo != null && this.userInfo.loginAccount){
              this.requestType=(this.currentTab=='images'||this.currentTab=='text')?'30001':'30002';
              if(this.currentTab == 'audios'){
                  //显示loading,避免获取音频需要空白等待太长时间
                  this.$store.commit('showLoading',true);
                  this.$store.commit('showLoadingBg',true);

              }
              //余额和条数是否充足
              this.$axios.request({
                url:'/webapi/sc/beforeAddEvidence',
                method:'GET',
                params: {
                  userId:this.userInfo.id,
                  time:this.time,
                  url:url,
                  type:this.searchTypes[this.currentTab],
                  productCode:this.requestType,
                  token:this.userInfo.token,
                }
              }).then(response=>{
                  this.$store.commit('showLoading',false);
                  this.$store.commit('showLoadingBg',false);
                  //处理音频的时间
                  if(this.currentTab == 'audios'){
                      this.time = response.data.datas.time;
                      console.log('audio time:',this.time);
                  }
                  //给总价默认值
                  this.totalSum = parseInt(this.charging[this.currentTab]);
                  //处理单价
                  let price = parseFloat(response.data.datas.unitPrice/100).toFixed(2);
                  switch(this.currentTab){
                      case 'text':
                      case 'images':
                          this.charging[this.currentTab] = price + '元/条';
                          this.totalSum = price;
                          break;
                      case 'videos':
                      case 'audios':
                          this.charging[this.currentTab] = price + '元/分钟';
                          this.totalSum = this.time * price;
                          break;
                  }
                  //将要存证的信息
                  let saveInfo=this.currentTab=='images'?this.imageArr[index]:this.results.data[index];
                  if(this.currentTab=='text'){
                      saveInfo.saveUrl =  response.data.datas.url;
                  }else if(this.currentTab=='images'){
                      saveInfo.saveUrl = this.imageArr[index].webUrl;
                  }else{
                      saveInfo.saveUrl = this.results.data[index].webUrl;
                  }
                  this.saveInfo = saveInfo;
                  //对余额和条数是否充足的结果做出处理
                  if(response.data.code==200){
                    this.isEnough = true;
                    this.showSave = true;
                  } else if(response.data.code==304){
                    this.isEnough = false;
                    this.showSave = true;
                  } else {
                    this.$store.dispatch('showMsgModal',{
                      autoClose:false,
                      info:response.data.message
                    });
                    return;
                  }
              });
              
          } else {
              //未登录的话跳到登录
              this.$store.commit('showPopWindow', 'loginWin');
          }

      },
      closePopup(){
         this.showSave = false;
      },
      goPersonalCenter(){
         this.$router.push('/personal_center/account_balance')
      },
      goAliPay () {

          //支付宝支付
//        let url = 'http://59.110.44.147:9060/webapi/webPay/alipayapi?money=0.01'
//          + '&userId='+ this.userInfo.id
//          + '&token='+ this.userInfo.token
//          + '&returnParams=' + returnParams;
//          let url = 'http://59.110.44.147:9060/webapi/webPay/alipayapi?money='+this.totalSum

//          window.open(url);

          let data = this.saveInfo.snapshotId == -1
              ? JSON.stringify([{
                'title':encodeURIComponent(this.saveInfo.webTitle),
                'url':this.saveInfo.saveUrl,
                'type':this.saveType[this.currentTab],
                'keyword':encodeURIComponent(this.keyword),
                'time':this.time
              }])
              : '';

//          this.totalSum = 0.01;
//          console.log('data to alipay is ', encodeURIComponent(data));
        let action = this.saveInfo.snapshotId == -1 ? 1 : 2;

        this.openPostWindow(GlobalConfig.webApiServer + '/webapi/webPay/alipayapi',
            this.totalSum,
            this.userInfo.id,
            this.userInfo.token,
            102,
            data,
            action,
            this.saveInfo.snapshotId
          );

        this.showSave = false;
        this.isEnough = true;
        this.isPaid = true;
      },
      openPostWindow (url, money,userId, token, type, data, action, snapshotId) {
          let newWin = window.open();
          let formStr = '';
          //设置样式为隐藏，打开新标签再跳转页面前，如果有可现实的表单选项，用户会看到表单内容数据
          formStr = '<form style="visibility:hidden;" method="POST" action="' + url + '">' +
            '<input type="hidden" name="money" value="' + money + '" />' +
            '<input type="hidden" name="userId" value="' + userId + '" />' +
            '<input type="hidden" name="token" value="' + token + '" />' +
            '<input type="hidden" name="type" value="' + type + '" />' +
            "<input type='hidden' name='data' value='" + data + "' />" +
            "<input type='hidden' name='action' value='" + action + "' />" +
            "<input type='hidden' name='snapshotId' value='" + snapshotId + "' />" +
            '</form>';

          newWin.document.body.innerHTML = formStr;
          newWin.document.forms[0].submit();

//          return newWin;
      },
      goConfirm (e) {
          e.target.disabled = true;
          this.$axios.request({
              url:'/webapi/sc/addEvidence',
              method: 'POST',
              data: {
                  userId:this.userInfo.id,
                  data: this.saveInfo.snapshotId == -1
                    ? JSON.stringify([{
                      'title':this.saveInfo.webTitle,
                      'url':this.saveInfo.saveUrl,
                      'type':this.saveType[this.currentTab],
                      'keyword':this.keyword,
                      'time':this.time
                      }])
                    : '',
                  action: this.saveInfo.snapshotId == -1 ? 1 : 2,
                  token:this.userInfo.token,
                  snapshotId: this.saveInfo.snapshotId

              }
          }).then(response=>{
              if(response.data.code==200){
                  this.showSave = false;
                  if(this.currentTab == 'images'){
                    this.imageArr[this.saveIndex].saveStatus = 0;
                    this.imageArr[this.saveIndex].statusDesc = '存证中';
                    this.imageArr[this.saveIndex].hasAction = false;
                  } else {
                    this.results.data[this.saveIndex].saveStatus = 0;
                    this.results.data[this.saveIndex].statusDesc = '存证中';
                    this.results.data[this.saveIndex].hasAction = false;
                  }
                  this.$store.dispatch('showMsgModal',{
                    autoClose:true,
                    info:'已提交存证'
                  });
              } else {
                  this.showSave = false;
                  this.$store.dispatch('showMsgModal',{
                    autoClose:false,
                    info:response.data.message
                  });
              }
              e.target.disabled = false;
          })
      },
      payComplete(){
          this.isPaid = false;
          this.dataRequest();
      }
    },
    watch: {
      '$route' (to, from) {
        //刷新参数放到这里里面去触发就可以刷新相同界面了
//        this.init();
        let keyword = to.query.keyword;
        if(this.getAccountNum != 0){
          clearInterval(this.getAccountNum);
          this.getAccountNum = 0;
        }
        if(
            (this.currentTab == to.path.substring(to.path.lastIndexOf('/')+1))
          && (this.keyword == decodeURIComponent(keyword))
        ){
          console.log('router goto in watch');
          this.goto();
        }else{
//          alert('router in watch');
          console.log('router init in watch');
          this.init();
        }
      }
    },
    beforeRouteLeave (to, from, next) {
      // 导航离开该组件的对应路由时调用
      // 可以访问组件实例 `this`
      if(this.getAccountNum != 0){
        clearInterval(this.getAccountNum);
        this.getAccountNum = 0;
      }
      next();
    },
  }
</script>




// WEBPACK FOOTER //
// ResultContainer.vue?4373cfba